import ListTransform from '@model/list/ListTransform'
import Locale from '@serv/Locale'
import ResourceService from '@serv/ResourceService'

class ListTransformCareNavigatorUser extends ListTransform {
    constructor(object) {
        object.filterKey = 'careNavigatorClinicianId'
        super(object)
    }

    get getFilterComponent() {
        return 'DataFilterString'
    }

    get getFilterConfig() {
        const careNavigators = ResourceService.getCareNavigatorProviders()

        return {
            title: Locale.getLanguageItem(this.column.label),
            valueLabels: careNavigators?.map(careNavigator => ({
                value: careNavigator.value,
                label: careNavigator.title
            })),
            addAll: true,
            addNone: true
        }
    }

    // Get a value suitable for use in request payload or query params, from the keyStrings value.
    getQueryParamValueFromKeyStrings(keyStrings, isGoddard) {
        if (keyStrings.length == 1 && keyStrings[0] == 'none') {
            return null
        }

        const values = Object.values(keyStrings)

        return isGoddard ? { values } : values
    }

    // Get the SQL report parameter to sort by
    getSortParameter() {
        return 'care_navigator_user_name'
    }
}

export default ListTransformCareNavigatorUser
